import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { demoPhone, demoSiteUrl } from '../../data/websites';
export function TryItNow() {
  return <section aria-labelledby="try-it-now" className="bg-brand-red px-[clamp(1rem,4vw,6rem)] py-20 lg:py-28" data-id="element-1063" data-mp="2a8gih7h0zd2f">
      <div className="grid items-center gap-10 lg:grid-cols-2 xl:gap-20" data-id="element-1064" data-mp="1ve1uesiltdgw">
        <div data-id="element-1065" data-mp="209h7hi8sf5c9">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-white/80" data-id="element-1066" data-mp="2097i9wvkh27m">Try it right now</p>
          <h2 id="try-it-now" className="mt-3 text-[clamp(2rem,3.2vw,3.75rem)] font-extrabold leading-tight tracking-tight text-white" data-id="element-1067" data-mp="1mhki3lyi79jk">
            Don’t take our word for it. Change our website.
          </h2>
          <p className="mt-6 max-w-[58ch] text-[clamp(1.0625rem,1.2vw,1.375rem)] leading-relaxed text-white/90" data-id="element-1068" data-mp="1hk12ahm5qopi">
            Call {demoPhone.display} and change the wording on our demo site,{' '}
            <a href={demoSiteUrl} target="_blank" rel="noopener noreferrer" className="font-bold text-white underline underline-offset-4 hover:text-brand-light" data-id="element-1069" data-mp="17mwfqgoegr86">
              vegastacotruck.com
            </a>
            . Pick a line of text, tell Ava what it should say, then refresh a few minutes later and watch it change.
          </p>
        </div>

        <div className="lg:justify-self-end" data-id="element-1070" data-mp="24rjvij7e3yzu">
          <a href={demoPhone.tel} className="inline-flex items-center gap-4 rounded-xl bg-brand-black px-8 py-6 text-white transition-colors duration-150 ease-out hover:bg-[#1f1f1f] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand-red" data-id="element-1071" data-mp="1h0nuqwkyhtgg">
            <span className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-brand-red" data-id="element-1072" data-mp="1lyz4l7b943yo">
              <PhoneIcon className="h-6 w-6" aria-hidden="true" data-id="element-1073" data-mp="y8ln2aqalnic" />
            </span>
            <span data-id="element-1074" data-mp="taac1wo9h6yj">
              <span className="block text-sm font-semibold text-gray-400" data-id="element-1075" data-mp="tatjukk76eyu">Call the demo line</span>
              <span className="block whitespace-nowrap text-[clamp(1.75rem,2.6vw,3rem)] font-extrabold leading-tight" data-id="element-1076" data-mp="1iyyzdi2c5vcm">
                {demoPhone.display}
              </span>
            </span>
          </a>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-white/80" data-id="element-1077" data-mp="1rtm2g7kj1vlp">
            One demo per caller. Demo changes are text only. The demo site resets every night at midnight.
          </p>
        </div>
      </div>
    </section>;
}